import { connect } from 'react-redux';
import { push } from 'redux-little-router';
import { submit } from 'redux-form/immutable';
import StepWizard from './StepWizard';
import { selectRouter } from 'modules/App/utils/selectors';

const mapStateToProps = (state) => ({
  router: selectRouter(state),
});
const mapDispatchToProps = {
  updateQueryStep: (query) => push({ query }, { persistQuery: true }),
  submitForm: (form) => submit(form),
};

export default connect(mapStateToProps, mapDispatchToProps)(StepWizard);
